import React from 'react';
import {connect} from "react-redux";
import CommonButton from "./CommonButton";
import {setClearResults} from '../../actions/filters';

const ClearButton=({panel, dispatch, filters})=>{
    return <CommonButton onClick={()=>{dispatch(setClearResults(panel, true));console.log(filters.clearResults);}} nameClass='icon-btn clear-btn'/>
};

const mapStateToProps=(state)=>({filters:state.filters});
const ConnectedClearButton=connect(mapStateToProps)(ClearButton);
export default ConnectedClearButton;